import { Lock } from "lucide-react";
import { Saguaro } from "@/components/Saguaro";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";

export const Footer = ({ property }) => {
  const { t } = useLang();
  return (
  <footer className="bg-foreground text-white/80 py-14">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 font-serif text-2xl font-semibold text-white mb-3">
            <Saguaro className="h-6 w-6 shrink-0" /> {property?.name}
          </div>
          <p className="text-sm text-white/60 max-w-xs">{t(property?.tagline)}</p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">{t("Explore")}</h4>
          <ul className="space-y-2 text-sm">
            {["gallery", "amenities", "reviews", "guide", "faq"].map((s) => (
              <li key={s}>
                <button onClick={() => document.querySelector(`#${s}`)?.scrollIntoView({ behavior: "smooth" })} className="hover:text-white capitalize transition-colors">
                  {s === "faq" ? "FAQ" : t(s.charAt(0).toUpperCase() + s.slice(1))}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-3">{t("Contact")}</h4>
          <p className="text-sm text-white/60">{property?.location}</p>
          <p className="text-sm text-white/60">{property?.contact_email}</p>
          {property?.whatsapp_number && <p className="text-sm text-white/60">{property?.whatsapp_number}</p>}
        </div>
      </div>
      <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/50">
        <span>© {new Date().getFullYear()} {property?.name}. {t("Booked directly, with love.")}</span>
        <div className="flex items-center gap-5">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-white transition-colors">{t("Privacy Policy")}</Link>
          <Link to="/terms" data-testid="footer-terms-link" className="hover:text-white transition-colors">{t("Terms & Conditions")}</Link>
          <Link to="/sms" data-testid="footer-sms-link" className="hover:text-white transition-colors">{t("SMS Terms")}</Link>
          <Link to="/admin/login" data-testid="admin-login-link" className="flex items-center gap-1.5 hover:text-white transition-colors">
            <Lock className="h-3.5 w-3.5" /> {t("Owner Login")}
          </Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
